"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MomentUtils_1 = require("./MomentUtils");
var moment = require("moment");
var defaultKeyMap = function (value, key) {
    return value ? value[key] : undefined;
};
exports.defaultKeyMap = defaultKeyMap;
var dateString = function (formats, keyMapFunc) {
    return function (value, key) {
        var f = keyMapFunc || defaultKeyMap;
        var keyValue = f(value, key);
        if (keyValue !== undefined) {
            var m = moment(String(keyValue), formats, true);
            return MomentUtils_1.isValidMoment(m) ? m.toDate() : undefined;
        }
    };
};
exports.dateString = dateString;
var mapped = function (map) {
    return function (value, key) {
        return (map[key] || defaultKeyMap)(value, key);
    };
};
exports.mapped = mapped;
